module.exports = window.__clic_libs["nouislider"];